import { cn } from "@newxsystems/shared";
import { KaajBlogPostCard } from "../../../../modules/blog/components/KaajBlogPostCard/KaajBlogPostCard";
import { KaajSectionShell } from "../../../../modules/layout/components/KaajSectionShell/KaajSectionShell";
import type { IFeaturedBlogPostsBlockProps } from "./FeaturedBlogPostsBlock.props";

const DEFAULT_HEADING = "Selected field notes";
const DEFAULT_EMPTY_TEXT = "No featured analysis has been selected.";

export const FeaturedBlogPostsBlock = (props: IFeaturedBlogPostsBlockProps) => {
  const { anchorId, blockName, eyebrow, id, posts, spacing, subheading } = props;
  const heading = Object.hasOwn(props, "heading") ? props.heading : DEFAULT_HEADING;
  const emptyText = Object.hasOwn(props, "emptyText") ? props.emptyText : DEFAULT_EMPTY_TEXT;
  const [firstPost, ...remainingPosts] = posts ?? [];
  const hasSecondaryPosts = remainingPosts.length > 0;

  return (
    <KaajSectionShell
      id={anchorId ?? id ?? blockName ?? undefined}
      eyebrow={eyebrow ?? undefined}
      heading={heading ?? undefined}
      spacing={spacing ?? "normal"}
      subheading={subheading ?? undefined}
    >
      {firstPost ? (
        <div
          className={cn(
            "grid gap-5 lg:gap-6",
            hasSecondaryPosts &&
              "lg:grid-cols-[minmax(0,1.55fr)_minmax(19rem,0.85fr)] lg:grid-rows-2",
          )}
        >
          <KaajBlogPostCard
            className={cn("min-h-[28rem] lg:min-h-[40rem]", hasSecondaryPosts && "lg:row-span-2")}
            post={firstPost}
            priority
            variant="featured"
          />
          {remainingPosts.slice(0, 2).map((post) => (
            <KaajBlogPostCard
              className="min-h-[22rem]"
              key={post.id}
              post={post}
              variant="featuredCompact"
            />
          ))}
          {remainingPosts.length > 2 ? (
            <div
              className={cn(
                "grid gap-5 md:grid-cols-2 lg:col-span-2 xl:grid-cols-3 lg:gap-6",
                remainingPosts.length === 3 && "xl:grid-cols-1",
              )}
            >
              {remainingPosts.slice(2).map((post) => (
                <KaajBlogPostCard key={post.id} post={post} />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="rounded-[1.5rem] border border-dashed border-[#AEBEFF] bg-[#FAFBFF] p-6 text-[#4B5568]">
          {emptyText}
        </div>
      )}
    </KaajSectionShell>
  );
};

FeaturedBlogPostsBlock.displayName = "Block::FeaturedBlogPostsBlock";
